import { useState, useEffect } from "react";

const ComponentePecaEncomendaRef = ({ item, dispachInfo, stateInfo }) => {


    useEffect(()=>{
        if(Object.keys(stateInfo.produtosSelecionados).length >= 1){
            console.log(stateInfo.produtosSelecionados)
        }
    },[stateInfo.produtosSelecionados])
    

    const [itemConfigurado, setItemConfigurado] = useState(null);

    // 🔄 Configura tamanhos apenas quando item muda
    useEffect(() => {
        if (!item) return;

        let novoItem = { ...item };

        if (!novoItem.configurado && typeof novoItem.tamanhos === "string") {
            let tamanhosObj = {};

            novoItem.tamanhos.split('####').forEach(t => {
                t = t.trim();
                if (!t) return;

                const match = t.match(/(.+?) - CODPROD (\d+) QTDE (\d+)/);

                if (match) {
                    const tamanho = match[1].trim();

                    tamanhosObj[tamanho] = {
                        tamanho,
                        codprod: Number(match[2]),
                        qtde: Number(match[3])
                    };
                }
            });

            novoItem = {
                ...novoItem,
                configurado: true,
                tamanhos: tamanhosObj
            };
        }

        setItemConfigurado(novoItem);

    }, [item]);

    // 🧠 Atualiza quantidade via reducer
    const alterarQuantidade = (val, delta) => {
        if (!itemConfigurado) return;

        const chaveItem = `${itemConfigurado.fabricante}-${itemConfigurado.item}-${itemConfigurado.loj_num}`;
        const chaveTam = `${val.codprod}`;

        dispachInfo({
            type: 'ALTERAR_QTDE',
            payload: {
                chaveItem,
                chaveTam,
                delta,
                limite: val.qtde,
                itemConfigurado
            }
        });
    };

    if (!itemConfigurado || !itemConfigurado.configurado) return null;

    return (
        <div className="componentePecaEncomendaRef">

            <div className="tituloRev">{itemConfigurado.rev_nom}</div>
            <div className="tituloRev">LOJA: {itemConfigurado.loj_nom}</div>
            <div className="forn">{itemConfigurado.fabricante}</div>

            <div className="cabecalho">
                <div className="item">{itemConfigurado.item}</div>
                <div className="pagina">Pag.: {itemConfigurado.pagina}</div>
                <div className="cor">COR.: {itemConfigurado.procor_descricao_cor}</div>
            </div>

            <div className="tamamnhoTitle">TAMANHOS</div>

            <div className="tamanhos">
                {Object.values(itemConfigurado.tamanhos).map((val) => {

                    const chaveItem = `${itemConfigurado.fabricante}-${itemConfigurado.item}-${itemConfigurado.loj_num}`;
                    const chaveTam = `${val.codprod}`;

                    const quantidadeAtual =
                        stateInfo.produtosSelecionados?.[chaveItem]?.tamanhos?.[chaveTam] || 0;

                    return (
                        <div className="cardTam" key={chaveTam}>
                            <div className="titulo">
                                {val.tamanho} (Disp: {val.qtde})
                            </div>

                            <div className="controle">
                                <button onClick={() => alterarQuantidade(val, -1)}>-</button>

                                <input
                                    type="number"
                                    value={quantidadeAtual}
                                    min={0}
                                    max={val.qtde}
                                    onChange={(e) => {
                                        let valor = Number(e.target.value);

                                        if (valor > val.qtde) valor = val.qtde;
                                        if (valor < 0) valor = 0;

                                        alterarQuantidade(val, valor - quantidadeAtual);
                                    }}
                                />

                                <button onClick={() => alterarQuantidade(val, +1)}>+</button>
                            </div>
                        </div>
                    );
                })}
            </div>

        </div>
    );
};

export default ComponentePecaEncomendaRef;